import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import { searchClose } from "@sharedJS/closeSearch";

const cartFlyout = ".js-flyout-cart";
let nowTapped;
let previousTapped;

function init() {
	minifiedHover();
	OcmMessenger.subscribe(messengerPublicationTypes.UPDATED_MINI_CART, updateMiniCartTotalItemCount);
}

function updateMiniCartTotalItemCount({ data }) {
	const $miniCartIcon = $("#miniCartIcon");

	if ($miniCartIcon.length < 1) {
		return;
	}

	const $miniCartCounterBadge = $(".js-miniCartCounter-badge");

	if (typeof data === "number") {
		$miniCartCounterBadge.text(data);
	} else {
		const url = `/rest/mini-cart/count`;
		$.ajax({
			url,
			global: false,
			type: "GET",
			dataType: "json",
		})
			.done((data) => {
				$miniCartCounterBadge.text(data);
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				console.error(errorThrown);
			});
	}
}

function minifiedHover() {
	const isTouchDevice = Modernizr.touchevents;
	if (!isTouchDevice) {
		$(document).on("mouseenter", cartFlyout, function () {
			if (window.location.pathname.endsWith("/cart/")) {
				return false;
			}
			$(this).addClass("is-open");
			searchClose();
		});

		$(document).on("mouseleave", cartFlyout, function () {
			$(this).removeClass("is-open");
		});
	} else {
		// touch
		const $flyoutCart = $(cartFlyout);

		$flyoutCart.on("touchstart", function (event) {
			const _this = this;
			const $this = $(this);

			if ($this.hasClass("is-open")) {
				event.stopPropagation();
			} else {
				$this.addClass("is-open");
				searchClose();
				event.preventDefault();
			}

			nowTapped = _this;
		});

		$("body").on("touchstart", () => {
			if (previousTapped) {
				$(previousTapped).removeClass("is-open");
			}
			previousTapped = nowTapped;
			nowTapped = null;
		});
	}
}

export { init, updateMiniCartTotalItemCount };
